const API_BASE = process.env.REACT_APP_SAAS_API_BASE_URL || '/api/saas';

export async function saasRequest(path, options = {}) {
  const token = localStorage.getItem('posSaasSession');
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || 'Request failed.');
  return data;
}
